// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"164":"a8fe900f","268":"2ff8a3ff"}[chunkId] + ".chunk.css";
};